import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './MyRiza.module.css';
import SendFeedbackIcon from 'assets/images/liefIcons/send-feedback.svg';
import Growth from 'assets/images/myRiza/growth.png';
import LifeShared from 'assets/images/myRiza/life-shared.svg';
import Love from 'assets/images/myRiza/love.svg';
import NestIcon from 'assets/images/myRiza/nest-icon.svg';
import Nest from 'assets/images/myRiza/nest.svg';
import ReportBugIcon from 'assets/images/myRiza/report-bug.svg';
import VideoModal from 'components/Modals/VideoModal/VideoModal';
import UserRecentActivityItem from 'components/UI/UserRecentActivityItem/UserRecentActivityItem';
import HelpTile from 'containers/UI/HelpTile/HelpTile';
import { getRandomInt } from 'shared/utility';
import * as actions from 'store/actions';

class MyRiza extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderedRecentActivityType: 'all',
      currentRizaTip: 0,
      showVideo: false,
      currentAllPageNumber: 1,
      currentMinePageNumber: 1,
    };
  }

  componentDidMount() {
    if (this.props.postingAs.UserId && this.props.signedInAs.UserId && this.props.postingAs.ProfileStatus === 'DONE') {
      this.handleFecthUserRecentActivity(this.state.renderedRecentActivityType, 1);
    }
    this.props.onFetchHelpContent();
  }

  componentDidUpdate(prevProps) {
    // On page setup, once signedInAs user and postingAs user have loaded, fetch recent activity
    // OR If user changes viewing site from one user to another (eg: switching from account owner to manage user,
    // refresh recent activity), reset page numbers to 1 and load the updated user's recent activity
    // OR a user has successfully added a DateBirthDay (when creating their profile, which then triggers the server to create their birthday post)
    if (this.props.postingAs.ProfileStatus === 'DONE') {
      if (
        (this.props.postingAs.DateBirthDay && !prevProps.postingAs.DateBirthDay) ||
        (this.props.postingAs.UserId !== null && prevProps.postingAs.UserId === null && typeof this.props.isManagedUser === 'boolean') ||
        (typeof prevProps.isManagedUser !== 'boolean' && typeof this.props.isManagedUser === 'boolean') ||
        (prevProps.postingAs.UserId && this.props.postingAs.UserId !== prevProps.postingAs.UserId)
      ) {
        this.handleFecthUserRecentActivity(this.state.renderedRecentActivityType, 1);
      }
    }

    if (prevProps.HelpCount === 0 && this.props.HelpCount > 0) {
      const randomlySelectedTip = getRandomInt(0, this.props.HelpCount - 1);
      if (randomlySelectedTip) this.setState({ currentRizaTip: randomlySelectedTip });
    }
  }

  handlePageVisit = (path) => {
    this.props.history.push(path);
  };

  handleFecthUserRecentActivity = (show, pageNum) => {
    // We currently fetch more recent activity items than are displayed because we're hiding Intention related activity.
    const currentPageNumberReference = show === 'all' ? 'currentAllPageNumber' : 'currentMinePageNumber';
    const updatedPageNumber = pageNum || this.state[currentPageNumberReference] + 1;
    this.props.onFetchUserRecentActivity(show, this.props.postingAs.UserId, this.props.isManagedUser, updatedPageNumber, 20);
    this.setState({ [currentPageNumberReference]: updatedPageNumber });
  };

  handleUpdateRenderedRecentActivityType = (show) => {
    if (show !== this.state.renderedRecentActivityType) {
      const recentActivityArray =
        show === 'all'
          ? this.props.userAllRecentActivity.filter((userActivity) => userActivity.Type !== 'Intention')
          : this.props.userMyRecentActivity.filter((userActivity) => userActivity.Type !== 'Intention');
      if (recentActivityArray.length < 1) this.handleFecthUserRecentActivity(show, 1);
      this.setState({ renderedRecentActivityType: show });
    }
  };

  handleRecentActivityClick = (goToUrl) => {
    this.props.history.push(goToUrl);
    this.props.history.push({
      pathname: goToUrl,
      state: { prevPath: '/my-riza/' },
    });
  };

  handleCarouselClick = (direction) => {
    const updatedRizaTipIndex =
      direction === 'previous'
        ? this.state.currentRizaTip > 0
          ? this.state.currentRizaTip - 1
          : this.props.HelpCount - 1
        : this.state.currentRizaTip < this.props.HelpCount - 1
        ? this.state.currentRizaTip + 1
        : 0;
    this.setState({ currentRizaTip: updatedRizaTipIndex });
  };

  toggleVideo = () => {
    this.setState({ showVideo: !this.state.showVideo });
  };

  handleShowUserSnapFeedbackTool = (feedbackType) => {
    const projectAPIKey = feedbackType === 'bug' ? process.env.REACT_APP_USERSNAP_BUG_API_KEY : process.env.REACT_APP_USERSNAP_FEEDBACK_API_KEY;
    window.Usersnap.show(projectAPIKey).then((widgetApi) => widgetApi.open());
  };

  render = () => {
    let recentActivityList = null;
    const recentActivityArray =
      this.state.renderedRecentActivityType === 'all'
        ? this.props.userAllRecentActivity.filter((userActivity) => userActivity.Type !== 'Intention')
        : this.props.userMyRecentActivity.filter((userActivity) => userActivity.Type !== 'Intention');
    if (recentActivityArray.length > 0) {
      recentActivityList = recentActivityArray.map((userActivity, i) => {
        // We currently fetch more recent activity items than are displayed because we're hiding Intention related activity.
        return (
          <UserRecentActivityItem
            key={`activity-item-${i}`}
            postingAs={this.props.postingAs}
            userActivity={userActivity}
            clicked={this.handleRecentActivityClick}
          />
        );
      });
    } else if (recentActivityArray.length === 0 && !this.props.loading && this.props.postingAs.UserId) {
      recentActivityList = <h3 className={classes.NoActivityAvailable}>No recent activity yet. Please check back soon!</h3>;
    }

    const helpContentArray = [];
    Object.keys(this.props.HelpContent).map((helpCategoryKey) =>
      this.props.HelpContent[helpCategoryKey].forEach((contentItem) => {
        const updatedContentItem = contentItem;
        updatedContentItem.TipType = helpCategoryKey;
        helpContentArray.push(updatedContentItem);
      }),
    );
    const currentRizaTip = helpContentArray[this.state.currentRizaTip];
    const currentRizaTipType = currentRizaTip
      ? currentRizaTip.TipType === 'mobile'
        ? 'mobile help videos'.toUpperCase()
        : currentRizaTip.TipType === 'web'
        ? 'Web Help Videos'.toUpperCase()
        : currentRizaTip.TipType === 'tips'
        ? 'riza tips'.toUpperCase()
        : currentRizaTip.TipType === 'faq'
        ? 'FAQs'
        : ''
      : '';
    return (
      <div className={classes.MyRizaContainer}>
        <VideoModal
          show={this.state.showVideo}
          toggleVideo={this.toggleVideo}
          title={currentRizaTip ? currentRizaTip.Name : ''}
          videoUrl={currentRizaTip && currentRizaTip.FileVideo ? currentRizaTip.FileVideo.FileURL : ''}
          orientation={currentRizaTip && currentRizaTip.FileVideo && currentRizaTip.TipType === 'web' ? 'horizontal' : 'vertical'}
        />

        <h2 className={classes.Welcome}>{this.props.postingAs.FirstName ? ` Welcome ${this.props.postingAs.FirstName}!` : '   '}</h2>
        <div className={classes.Dashboard}>
          <div className={classes.RecentActivityContainer}>
            <h3 className={classes.Title}>RECENT ACTIVITY</h3>
            <div className={classes.Options}>
              <p
                className={this.state.renderedRecentActivityType === 'all' ? [classes.Option, classes.Selected].join(' ') : classes.Option}
                onClick={() => this.handleUpdateRenderedRecentActivityType('all')}
              >
                All
              </p>
              <p
                className={this.state.renderedRecentActivityType === 'mine' ? [classes.Option, classes.Selected].join(' ') : classes.Option}
                onClick={() => this.handleUpdateRenderedRecentActivityType('mine')}
              >
                {this.props.postingAs.FirstName}
              </p>
            </div>
            <div className={classes.RecentActivityList}>
              <InfiniteScroll
                element="div"
                dataLength={recentActivityArray.length}
                next={() => this.handleFecthUserRecentActivity(this.state.renderedRecentActivityType)}
                endMessage=""
                height="390px"
                hasMore={
                  this.state.renderedRecentActivityType === 'all' ? this.props.hasMoreUserAllRecentActivity : this.props.hasMoreUserMyRecentActivity
                }
              >
                {recentActivityList}
              </InfiniteScroll>
            </div>
          </div>
          <div className={classes.TipsAndFeedbackContainer}>
            <div className={classes.TipsContainer}>
              <h2 className={classes.RizaTips}>{currentRizaTipType}</h2>
              <div className={classes.TipsInnerContainer}>
                {currentRizaTip && currentRizaTip.FileImage ? (
                  <HelpTile
                    toggle={this.toggleVideo}
                    videoUrl={currentRizaTip.FileVideo ? currentRizaTip.FileVideo.FileURL : ''}
                    imageUrl={currentRizaTip.FileImage ? currentRizaTip.FileImage.FileURL : ''}
                    id={currentRizaTip.Id}
                    videoHostName={currentRizaTip.ByDisplayName}
                    videoLengthInSeconds={currentRizaTip.FileVideo ? currentRizaTip.FileVideo.DurationInMs / 1000 : null}
                    showVideo={this.state.showVideo}
                  />
                ) : null}
                <div
                  className={currentRizaTip && currentRizaTip.FileImage ? classes.RightSection : [classes.RightSection, classes.FullWidth].join(' ')}
                >
                  <div className={classes.TipDetails}>
                    <h2 id="tip-title" className={classes.TipTitle}>
                      {currentRizaTip ? currentRizaTip.Name : ''}
                    </h2>
                    <p className={classes.Description}>{currentRizaTip ? currentRizaTip.FullDesc : ''}</p>
                  </div>

                  <div className={classes.BottomSection}>
                    <div className={classes.TipsCarousel}>
                      <FontAwesomeIcon icon="chevron-left" className={classes.CarouselIcon} onClick={() => this.handleCarouselClick('previous')} />
                      <FontAwesomeIcon icon="chevron-right" className={classes.CarouselIcon} onClick={() => this.handleCarouselClick('next')} />
                    </div>
                    <h3 onClick={() => this.props.history.push('/help')}>More Help</h3>
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.BugsAndFeedbackContainer}>
              <div className={classes.SendFeedback}>
                <img src={SendFeedbackIcon} alt="send-feedback" className={classes.SendFeedbackIcon} />
                <h3 onClick={() => this.handleShowUserSnapFeedbackTool('feedback')}>Send Ideas and Feedback</h3>
              </div>
              <div className={classes.ReportBug}>
                <img src={ReportBugIcon} alt="report-bug" className={classes.ReportBugIcon} />
                <h3 onClick={() => this.handleShowUserSnapFeedbackTool('bug')}>Send a Bug Report</h3>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.PageCallouts}>
          <div className={[classes.PageCallout, classes.LifeShared].join(' ')} style={{ backgroundImage: `url(${LifeShared})` }}>
            <div className={classes.Content}>
              <h2>Life, Shared</h2>
              <p>Organize and share your whole life with your closest people</p>
            </div>
            <div className={classes.Visit} onClick={() => this.handlePageVisit('/life-shared/timeline/')}>
              <FontAwesomeIcon icon="share" className={classes.VisitIcon} />
              <p>Life Shared</p>
            </div>
          </div>
          <div className={[classes.PageCallout, classes.Growth].join(' ')} style={{ backgroundImage: `url(${Growth})` }}>
            <div className={classes.Content}>
              <h2>Growth-in-Community</h2>
              <p>Become your best self with the help of others</p>
            </div>
            <div className={classes.Visit} onClick={() => this.handlePageVisit('/growth/')}>
              <FontAwesomeIcon icon="seedling" className={classes.VisitIcon} />
              <p>Growth</p>
            </div>
          </div>
          <div className={[classes.PageCallout, classes.Nest].join(' ')} style={{ backgroundImage: `url(${Nest})` }}>
            <div className={classes.Content}>
              <h2>Nest</h2>
              <p>Build and grow networks of support for a good life</p>
            </div>
            <div className={classes.Visit} onClick={() => this.handlePageVisit('/nest/')}>
              <img src={NestIcon} className={classes.VisitIcon} />
              <p>Nest</p>
            </div>
          </div>
          <div className={[classes.PageCallout, classes.Love].join(' ')} style={{ backgroundImage: `url(${Love})` }}>
            <div className={classes.Content}>
              <h2>Love</h2>
              <p>Act on your intentions, create shareable collections, pass it on.</p>
            </div>
            <div className={classes.Visit} onClick={() => this.handlePageVisit('/love/')}>
              <FontAwesomeIcon icon="heart" className={classes.VisitIcon} />
              <p>Love</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    postingAs: state.user.postingAs,
    signedInAs: state.user.signedInAs,
    isManagedUser: state.user.signedInAs.UserId && state.user.postingAs.UserId && state.user.signedInAs.UserId !== state.user.postingAs.UserId,
    userAllRecentActivity: state.recent.userAllRecentActivity,
    userMyRecentActivity: state.recent.userMyRecentActivity,
    hasMoreUserAllRecentActivity: state.recent.hasMoreUserAllRecentActivity,
    hasMoreUserMyRecentActivity: state.recent.hasMoreUserMyRecentActivity,
    loading: state.recent.loading || state.user.loading,
    HelpContent: state.help.HelpContent,
    HelpCount: state.help.HelpCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchUserRecentActivity: (Show, UserId, isManagedUser, Page, PageSize) =>
      dispatch(actions.fetchUserRecentActivity(Show, UserId, isManagedUser, Page, PageSize)),
    onFetchHelpContent: (HelpType) => dispatch(actions.fetchHelpContent(HelpType)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyRiza));
